import { useState, useEffect } from "react";
import { useGetAllCampaignGroupQuery } from "src/services/CampaignGroup";
const useCampaignGroup = () => {
    const [CampaignGroup, setCampaignGroup] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetAllCampaignGroupQuery("");

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setCampaignGroup(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { CampaignGroup, isDataLoading };
};

export default useCampaignGroup;
